import { Component, OnInit } from '@angular/core';


@Component({
    selector: 'device-filters',
    templateUrl: './device-filters.component.html',
    styleUrls: ['./device-filters.component.scss']
})

export class DeviceFiltersComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
    }


}
